import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { GateAccess } from "../utils/types/gateAccess";

export const fetchGateAccessList = async () => {
  const response = await axiosServices.get(`/gateaccess`);
  return convertToCamelCase<GateAccess[]>(response.data.data);
};

export const addGateAccessData = async (data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/gateaccess`, inputData);
  return convertToCamelCase<GateAccess>(response.data.data);
};

export const updateGateAccessData = async (id: string, data: { [key: string]: any }) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.put(`/gateaccess/${id}`, inputData);
  return convertToCamelCase<GateAccess>(response.data.data);
};

export const deleteGateAccessData = async (id: string) => {
  const response = await axiosServices.delete(`/gateaccess/${id}`);
  return { success: response.data.success, id };
};

export const generateGateListData = async (companyName: string, companyId?: string, template?: string) => {
  const response = await axiosServices.post(`/gateaccess/generate`, {
    ...(companyId ? { company_id: companyId } : { company_name: companyName }),
    ...(template ? { template } : {}),
  });
  return response.data;
};
